<template>
  <div class="pb-3">
    <section id="api_users_verify" class="pt-2">
      <h4 class="pb-2">Подтверждение восстановления пароля</h4>
      <div class="nav-api">
        <ul class="nav nav-tabs nav-tabs-clean">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="post">POST</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">{{ url }}/{{ method }}</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs">Параметры</span>
          </li>
        </ul>
        <div class="tab-content tab-content-table">
          <div class="tab-pane fade show active">
            <table class="table m-0 table-sm">
              <thead>
                <tr>
                  <th>Название</th>
                  <th>Тип</th>
                  <th>Требования</th>
                  <th>Описание</th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>secret</td>
                  <td>строка</td>
                  <td>обязательное поле</td>
                  <td>код восстановления</td>
                </tr>
                <tr>
                  <td>password</td>
                  <td>строка</td>
                  <td>обязательное поле, от 8 до 32 символов</td>
                  <td>новый пароль</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="example">Пример</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div
            class="tab-pane fade show active">curl -X POST -d "secret=a642b48e38150be8a54a7981bfc69441&password=8yGZmz8FGrhu" {{ url }}/{{ method }}</div>
        </div>

        <ul class="nav nav-tabs nav-tabs-clean mt-3">
          <li class="nav-item">
            <span class="nav-link active px-2 py-1 fs-xs" data-type="success">Ответ</span>
          </li>
        </ul>
        <div class="tab-content p-2">
          <div class="tab-pane fade show active">
            <pre class="mb-0">HTTP/1.1 200 OK
{
  "status": "success",
  "token": "526e7770d070cb889ddb849128320043"
}</pre>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>

<script>
  export default {
    props: ['url', 'token', 'user'],
    data() {
      return {
        method: 'v1/users/restore/verify'
      }
    }
  }
</script>